import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import { LandingPage } from './pages/landing'

/**
 * Marketing site. One surface — the splash at `/`; any other path lands
 * there too. No auth state, and the only backend call is the demo form.
 */
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
